import React from 'react';
import { buildClassName } from 'utils/build-class-name';
import styles from './style.module.scss';
import { PropsWithTestId } from 'types/testId';
import { listingPageModalIds } from 'constants/test-constants';
import { PricePresentation } from 'domain/price';

type PriceProps = PropsWithTestId<{
  presentation: PricePresentation;
  originalListPrice?: string;
  listPricePrefix?: string;
}>;

/**
 * Pure presentation component for displaying listing prices.
 * Renders price information provided by the PricePresentation model.
 */
export default function Price({ presentation, originalListPrice, listPricePrefix, testId }: PriceProps) {
  return (
    <div className={styles.component}>
      {presentation.showSoldPriceSection && (
        <div className={styles['sold-wrapper']}>
          <div className={styles.price} data-testid={testId}>
            {presentation.soldPriceDisplay}
          </div>
          {presentation.showOriginalListPrice && originalListPrice && (
            <div className={styles['list-price']}>
              <span data-testid={listingPageModalIds.soldListingListedPrice}>{originalListPrice}</span>
            </div>
          )}
        </div>
      )}
      {presentation.showListPriceSection && (
        <div>
          <div className={buildClassName(styles.price, presentation.isSoldWithoutSoldPrice && styles['list-price-only'])} data-testid={testId}>
            {presentation.shouldShowListPrefix && listPricePrefix}{presentation.listPriceDisplay}
          </div>
        </div>
      )}
    </div>
  );
}
